import React from "react";

const WhatsAppFloat = () => {
  return (
    <a
      href="https://wa.me/917890090500?text=Hello, I need some assistance with downloading the Formax Pay app. Could you please guide me?"
      className="whatsapp-float animate__animated animate__bounceIn animate__delay-2s"
      target="_blank"
      rel="noopener noreferrer"
    >
      <i className="fab fa-whatsapp"></i>
    </a>
  );
};

export default WhatsAppFloat;
